import { createContext, useContext, useState, useEffect } from 'react';

const AlertContext = createContext();

export function AlertProvider({ children }) {
  const [message, setMessage] = useState('');
  const [visible, setVisible] = useState(false);
  const [autoClose, setAutoClose] = useState(false);

  const [status, setStatus] = useState('erro');

  const [currentStep, setCurrentStep] = useState(localStorage.getItem('currentStep'));

  const showAlert = (msg, type = 'normal', statusType = 'erro') => {
    setMessage(msg);
    setVisible(true);
    setAutoClose(type === 'tempo');
    setStatus(statusType);
  };


  const closeAlert = () => {
    setVisible(false);
    setMessage('');
  };

  // Fecha automaticamente após 6 segundos se for do tipo "tempo"
  useEffect(() => {
    if (visible && autoClose) {
      const timer = setTimeout(() => {
        closeAlert();
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [visible, autoClose]);





  useEffect(() => {
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === 'currentStep') {
        const newValue = value;
        setCurrentStep(newValue);
      }
    };

    return () => {
      localStorage.setItem = originalSetItem;
    };
  }, []);


  // useEffect(() => {
  //   if (visible) {
  //     closeAlert();
  //   }
  // }, [currentStep]);


  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        closeAlert();
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [currentStep]);



  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {visible && (
        <div
          className={`alert-box ${status} ${visible ? 'show' : ''}`}
          style={{ justifyContent: autoClose ? 'center' : 'space-between' }}
        >
          <span>{message}</span>
          {!autoClose && (
            <span className="close-btn" onClick={closeAlert}>×</span>
          )}
        </div>
      )}
    </AlertContext.Provider>
  );
}

export function useAlert() {
  return useContext(AlertContext);
}
